/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

// Components
import SEO from 'components/SEO'
import GravityForm from 'components/GravityForm'

import { FaFacebookF } from 'react-icons/fa'
import { Layout, Services, CTA } from 'components/shared'
import { Heading, SocialIcon } from 'components/elements'

const MapContainer = styled.div`
  width: 100%;
  height: 440px;
  margin-bottom: -7px;
  position: relative;
  display: flex;
`
const BottomSection = styled.div`
  margin-bottom: 140px;
`
const ContactForm = styled.form`
  width: 1040px;
  border: 8px solid #d8d8d8;
  padding: 40px 100px 50px 100px;
  transition: all 300ms ease;
  @media screen and (max-width: 1060px) {
    border: 6px solid #d8d8d8;
    padding: 27px 60px 35px 60px;
    width: 700px;
    margin: 100px auto 100px auto;
  }
  @media (min-width: 768px) {
    margin: 140px auto 140px auto;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 20px 40px 30px 40px;
  }
`

export const pageQuery = graphql`
  query ($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      title
      path
      acf {
        info {
          streetname
          area
          phone
          email
        }
        cta {
          description
          link {
            title
            url
          }
        }
        services: service_relations {
          relations
        }
      }

      yoastMeta: yoast_meta {
        name
        content
        property
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { path, yoastMeta, acf },
  },
}) => {
  const { info, cta, services } = acf

  return (
    <Layout headerActive="Contact">
      <SEO yoast={{ meta: yoastMeta }} pathname={path} article />
      <MapContainer>
        <div className="d-md-block d-none">
          <iframe
            title="Google Map"
            style={{ position: 'absolute', zIndex: 3 }}
            width="100%"
            height="440"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2442.584613984782!2d5.372928552011343!3d52.25092817966484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c63f4d990eb031%3A0x4560a5a98ac5fc6!2sColijnstraat%2025%2C%203752%20AP%20Bunschoten-Spakenburg!5e0!3m2!1snl!2snl!4v1647958683867!5m2!1snl!2snl"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
          />
        </div>

        <ContactInfo
          address={info.streetname}
          area={info.area}
          phone={info.phone}
          email={info.email}
        />
      </MapContainer>
      <CTA
        text={cta.description}
        button={{
          title: cta.link.title,
          url: cta.link.url,
        }}
      />
      <ContactForm>
        <Heading text="CONTACTFORMULIER" />
        <GravityForm id={1} />
      </ContactForm>

      <div className="d-md-none d-block mb-5">
        <iframe
          title="Google Map"
          style={{ position: 'relative', zIndex: 3 }}
          width="100%"
          height="440"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2442.6186367326513!2d5.36479211626363!3d52.25031026393234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c63f4fe1bba9e5%3A0x893a234a3a4ae5c!2sHoveniersbedrijf%20Hoksbergen!5e0!3m2!1snl!2snl!4v1631694865370!5m2!1snl!2snl"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
        />
      </div>
      <BottomSection>
        <Heading
          text={'DIENSTEN VAN\nSCHOONEBEEK HOVENIERS'}
          className="mt-1"
        />
        <Services ids={services.relations} />
      </BottomSection>
    </Layout>
  )
}

export default PageTemplate

const ContactInfoContainer = styled.div`
  position: relative;
  z-index: 6;
  padding-right: 3rem;
  width: 360px;
  height: 360px;
  padding-top: 46px;
  background: ${(props) => props.theme.color.face.contrast};
  margin: auto calc(50% - 530px) auto auto;
  display: flex;
  font-weight: 500;
  flex-direction: column;
  @media screen and (max-width: 1060px) {
    margin: auto calc(50% - 384px) auto auto;
  }
  @media screen and (max-width: 767px) {
    width: 320px;
    height: 320px;
    margin: auto auto;
  }
`
const ContactInfoTitle = styled.h3`
  text-align: center;
  font-size: 25px;
  line-height: 30px;
  color: #fff;
  font-weight: 500;
  padding: 0 20px 25px 20px;
  border-bottom: 3px solid white;
  text-transform: uppercase;
  width: fit-content;
  margin: 0 auto 24px auto;
  @media screen and (max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
    padding: 0 16px 20px 16px;
    border-bottom: 2px solid white;
    margin: 0 auto 16px auto;
  }
`
const ContactInfoAddress = styled.div`
  text-align: left;
  color: #fff;
  font-size: 13px;
  line-height: 30px;
  width: 260px;
  margin: 0 auto 2px auto;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 24px;
  }
`
const ContactInfoPhone = styled.div`
  &:before {
    content: 'T';
    color: white;
    margin-right: 4px;
  }
  color: #fff;
  font-size: 13px;
  line-height: 30px;
  width: 260px;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 24px;
  }
`
const ContactInfoEmail = styled.div`
  &:before {
    content: 'E';
    color: white;
    margin-right: 4px;
  }
  color: #fff;
  width: 260px;
  text-transform: uppercase;
  font-size: 13px;
  line-height: 30px;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 24px;
  }
`
const ContactInfo = ({ address, phone, email, area }) => {
  return (
    <ContactInfoContainer>
      <ContactInfoTitle>CONTACT</ContactInfoTitle>
      <ContactInfoAddress>{address}</ContactInfoAddress>
      {area && <ContactInfoAddress>{area}</ContactInfoAddress>}
      <ContactInfoPhone>{phone}</ContactInfoPhone>
      <ContactInfoEmail>{email}</ContactInfoEmail>

      <div className="d-flex justify-content-center mt-4">
        <SocialIcon
          href="https://nl-nl.facebook.com/hoveniersbedrijfhoksbergen/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <FaFacebookF />
        </SocialIcon>
      </div>
    </ContactInfoContainer>
  )
}
